/* ============================================================
   SG SIZE CHARTS — custom size tables (more than 4 columns)
   ------------------------------------------------------------
   THIS IS THE ONLY FILE YOU EDIT TO ADD PRODUCTS OR TABLES.

   1. presets = the actual tables. Any number of columns.
        columns       : header names, in order.
                        The FIRST one is the sticky left column.
        in / cm       : one array per row, values in the SAME
                        order as `columns`.
        unitSuffix    : true  -> adds  "  or  cm  after numbers
                        false -> shows the value exactly as typed
        hideFitGuides : true hides TRIMESTER + BODY TYPE grids
        title / subtitle / note : optional text overrides

   2. byId = product ID -> preset name
        Admin URL: /admin/products/10258733334692
                   the number at the end is the ID.

   To add a product: find its ID, add one line in byId pointing
   to the preset you want. That is the whole process.
   ============================================================ */

window.SG_SIZE_CHARTS = {

  presets: {

    /* ---------- PANTS — SIZES S to XXL ---------- */
    pants_standard: {
      title: 'Product Size Chart',
      subtitle: 'Maternity Collection — Choose your perfect fit',
      unitSuffix: true,
      hideFitGuides: false,
      columns: [
        'Sizes',
        'Garment Waist',
        'To Fit Waist',
        'Inseam Length',
        'Outseam Length',
        'Hip',
        'To Fit Hip'
      ],
      in: [
        ['S',   '26', '28', '28',   '42', '38', '36'],
        ['M',   '28', '30', '26.5', '39', '38', '36'],
        ['L',   '30', '32', '26',   '39', '40', '38'],
        ['XL',  '32', '34', '25.5', '39', '42', '40'],
        ['XXL', '34', '36', '25',   '39', '44', '42']
      ],
      cm: [
        ['S',   '66',   '71',   '71',   '106.5', '96.5',  '91.5'],
        ['M',   '71',   '76',   '67.5', '99',    '96.5',  '91.5'],
        ['L',   '76',   '81.5', '66',   '99',    '101.5', '96.5'],
        ['XL',  '81.5', '86.5', '65',   '99',    '106.5', '101.5'],
        ['XXL', '86.5', '91.5', '63.5', '99',    '111.5', '106.5']
      ]
    },

    /* ---------- PANTS — SIZES M to XXL (no S) ---------- */
    pants_m_xxl: {
      title: 'Product Size Chart',
      subtitle: 'Maternity Collection — Choose your perfect fit',
      unitSuffix: true,
      hideFitGuides: false,
      columns: [
        'Sizes',
        'Garment Waist',
        'To Fit Waist',
        'Inseam Length',
        'Outseam Length',
        'Hip',
        'To Fit Hip'
      ],
      in: [
        ['M',   '28', '30', '26.5', '39', '38', '36'],
        ['L',   '30', '32', '26',   '39', '40', '38'],
        ['XL',  '32', '34', '25.5', '39', '42', '40'],
        ['XXL', '34', '36', '25',   '39', '44', '42']
      ],
      cm: [
        ['M',   '71',   '76',   '67.5', '99', '96.5',  '91.5'],
        ['L',   '76',   '81.5', '66',   '99', '101.5', '96.5'],
        ['XL',  '81.5', '86.5', '65',   '99', '106.5', '101.5'],
        ['XXL', '86.5', '91.5', '63.5', '99', '111.5', '106.5']
      ]
    },

    /* ---------- PANTS — LONG (M to XXL, 42" outseam) ---------- */
    pants_long: {
      title: 'Product Size Chart',
      subtitle: 'Maternity Collection — Choose your perfect fit',
      unitSuffix: true,
      hideFitGuides: false,
      columns: [
        'Sizes',
        'Garment Waist',
        'To Fit Waist',
        'Inseam Length',
        'Outseam Length',
        'Hip',
        'To Fit Hip'
      ],
      in: [
        ['M',   '28', '30', '27.5', '42', '40', '38'],
        ['L',   '30', '32', '27',   '42', '42', '40'],
        ['XL',  '32', '34', '26.5', '42', '44', '42'],
        ['XXL', '34', '36', '26',   '42', '46', '44']
      ],
      cm: [
        ['M',   '71',   '76',   '70',   '106.5', '101.5', '96.5'],
        ['L',   '76',   '81.5', '68.5', '106.5', '106.5', '101.5'],
        ['XL',  '81.5', '86.5', '67.5', '106.5', '112',   '106.5'],
        ['XXL', '86.5', '91.5', '66',   '106.5', '117',   '112']
      ]
    }

    /* Add more presets below. Copy a block above, put a comma
       after the block before it, rename it, change columns + rows:

    ,kurta_set: {
      title: 'Kurta Set Size Chart',
      unitSuffix: true,
      columns: ['Sizes', 'Bust', 'Waist', 'Hip', 'Kurta Length', 'Sleeve Length'],
      in: [
        ['S', '34', '28', '36', '46', '18'],
        ['M', '36', '30', '38', '46', '18']
      ],
      cm: [
        ['S', '86', '71', '91', '117', '46'],
        ['M', '91', '76', '96', '117', '46']
      ]
    }

    */
  },

  /* ==========================================================
     PRODUCT ID -> PRESET NAME
     One line per product. Comma after every line except the
     last one overall.
     ========================================================== */
  byId: {

    /* ---- S to XXL ---- */
    '10258733334692': 'pants_standard',
    '10267449098404': 'pants_standard',
    '10267449295012': 'pants_standard',
    '10258733269156': 'pants_standard',

    /* ---- M to XXL (no S) ---- */
    '10267449327780': 'pants_m_xxl',
    '10267449131172': 'pants_m_xxl',
    '10258733236388': 'pants_m_xxl',
    '10258733301924': 'pants_m_xxl',
    '10267449229476': 'pants_m_xxl',
    '10258733203620': 'pants_m_xxl',

    /* ---- LONG (42" outseam) ---- */
    '10258733432996': 'pants_long',
    '10258733400228': 'pants_long',
    '10258733367460': 'pants_long'
  }
};